const mapRolesConfigToAuthorization = config => {
    const authorization = {
        superAdmin: false,
        services: [],
        subpages: []
    };

    for (const [roleType, roleTypeValue] of Object.entries(config.roles)) {
        if (roleType === 'superAdmin' && roleTypeValue === true) {
            authorization.superAdmin = true;
        } else if (roleTypeValue) {
            for (let i = 0; i < state().configGroups.length; i++) {
                const group = state().configGroups[i];
                if (authorization.superAdmin || group.role.includes(roleType)) {
                    if (group.authorizeService && authorization.services.indexOf(group.authorizeService) === -1) {
                        authorization.services = authorization.services.concat(group.authorizeService);
                    }
                    if (group.authorizeSubpages) {
                        group.authorizeSubpages.forEach(subpage => {
                            if (authorization.subpages.indexOf(subpage) === -1) {
                                authorization.subpages = authorization.subpages.concat(subpage);
                            }
                        });
                    }
                }
            }
        }
    }

    return authorization;
};

const state = () => ({
    authorization: null,
    configGroups: [
        {
            role: ['superAdmin'],
            authorizeService: 'administration'
        },
        {
            role: ['standard', 'superAdmin'],
            authorizeService: 'accMgmt'
        },
        {
            role: ['superAdmin', 'serviceManager'],
            authorizeService: 'serviceMgmt',
            authorizeSubpages: ['services', 'access']
        }
    ],
    userRoles: null,
    connected: false
});

const mutations = {
    async setUserRolesAndAuthorization(state, config) {
        state.userRoles = config.roles;
        state.authorization = mapRolesConfigToAuthorization(config);
        state.connected = true;
    }
};

export default {
    namespaced: true,
    state,
    mutations
};
